import { proxy } from 'valtio';

import { ComponentQuery, DiagramComponentInstance } from 'models';

import type { SavedComponentSearch } from 'components/component-overview/ComponentOverview.Diagram';

type ProductLinking = {
    componentInstance: DiagramComponentInstance | null;
    linkedComponentId: string | null;
    defaultValues?: Partial<ComponentQuery>;
    savedSearch?: SavedComponentSearch;
};

const productLinkingStateDefaults: ProductLinking = {
    componentInstance: null,
    linkedComponentId: null,
    defaultValues: undefined,
    savedSearch: undefined,
};

const productLinkingState = proxy<ProductLinking>({ ...productLinkingStateDefaults });

export type { ProductLinking };
export { productLinkingState, productLinkingStateDefaults };
